import { Lot } from './../models/reference-reference.model';
import { environment } from "environments/environment";

export const locale = {
  lang: "es",
  data: {
    MENU: {
      EXAMPLE: "Ejemplo",
      TABLE: "Tabla",
      FORM: "Formulario",
    },
    GENERAL: {
      FILTERS: "Filtros",
      RESET_FILTERS: "Reiniciar filtros",
      LOADING: "Cargando...",
      ADD: "Añadir",
      EDIT: "Editar",
      DELETE: "Eliminar",
      ERROR: "Error",
      RECOVER_DATA_ERR: "No se han podido recuperar los datos",
      CODE: "Código",
      DAY: "Dia",
      DESCRIPTION: "Descripción",
      ACTIONS: "Acciones",
      OK: "OK",
      CANCEL: "Cancelar",
      CORRECT_UPDATE: "Actualizado correctamente",
      BAD_UPDATE: "No se ha actualizado",
      CORRECT_SAVE: "Se ha creado correctamente",
      BAD_SAVE: "No se ha creado correctamente",
      LOGIN: "Entrar",
      USER_CODE: "Código de usuario",
      LANGUAGE: "Idioma",
      USER: "Usuario",
      PLANIFICATION: "Planificación",
      MACHINES: "Máquinas",
      ERROR_RECOVERING_DATA: "Error recuperando los datos",
      MACHINE_NOT_SELECTED: "Máquina no seleccionada",
      OFFLINE: "Desconectado",
      SELECT: "Seleccionar",
      SELECT_MACHINE: "Selecciona una máquina",
      SELECT_OF: "Selecciona una OF",
      ONLY_ASSIGNED_TO_THIS_MACHINE: "Solo asignadas a esta máquina",
      SHOW_UNASSIGNED: "Incluir no asignadas",
      SEARCH_OF: "Buscar OF",
      PREPARE_MACHINE: "Preparar máquina",
      CONNECTION_LOST: "Conexión perdida",
      CONNECTION_LOST_ERROR:
        "Se ha perdido la conexión, la aplicación no puede funcionar correctamente",
      START: "Comenzando",
      PROD: "Producción",
      IDLE: "Detenida",
      EMERG: "Emergencia",
      PREP: "Preparación",
      OF_NUMBER: "Número OF",
      REFERENCE: "Referencia",
      PHASE: "Fase",
      PREPARED_BY: "Preparado por",
      SELECT_NEW_OF: "Seleccionar nueva OF",
      START_PRODUCTION: "Empezar producción",
      START_DATE: "Fecha inicio",
      END_DATE: "Fecha fin",
      MACHINE: "Máquina",
      OF: "OF",
      QUANTITY: "Cantidad",
      OBSERVATIONS: "Observaciones",
      PRODUCTION_SHEET: environment.eurogerm
        ? "Ficha de producción"
        : "Observaciones",
      NO_PRODUCTION_SHEET: environment.eurogerm
        ? "No hay ficha de producción"
        : "No hay observaciones",
      CLOSE: "Cerrar",
      PREPARATION_ENDED: "Preparación terminada",
      PRODUCTION_ENDED: "Producción terminada",
      NO_PLANIFICATIONS: "Actualmente, no tiene ninguna planificación",
      SELECT_REFERENCE: "Seleccionar referencia",
      MULTIPLE_MACHINES:
        "La OF seleccionada está configurada para ser producida en otra máquina. ¿ En que máquina quiere producirla ?",
      COMPONENTS: "Componentes",
      TIME_PREPARATION: "Tiempo de preparación",
      TIME_PRODUCTION: "Tiempo de producción",
      TIME_LEFT: "Tiempo restante",
      PRODUCED_BY: "Producido por",
      PRODUCTION: "Producción",
      PIECES_OK: "Piezas OK",
      PIECES_NOK: "Piezas NOK",
      ASSIGN_TO_PRODUCTION: "Asignar a producción",
      ASSIGN_UNASSIGNED: "S'han producido piezas fuera de producción",
      ASSIGN_UNASSIGNED_MESSAGE:
        "{{count}} piezas se han producido desde la última producción. La primera pieza se produjo el día {{startDate}} i la última pieza se produjo el día {{endDate}}.",
      DISCARD: "Descartar",
      ASSIGN: "Asignar",
      PROTOTYPE: "Prototipo",
      PRODUCTION_TYPE: "Tipo de producción",
      JUSTIFY_NOK: "Justificar NOK",
      NOK_JUSTIFIED_PIECES: "NOK piezas justificadas",
      TOTAL_PIECES_NOK: "Total piezas NOK",
      STOP_PRODUCTION: "Finalizar producción",
      ERROR_STARTING: "Error al iniciar la producción",
      STOP_PREPARATION: "Finalizar preparación",
      CADENCE: "Cadencia",
      CONTAINER_CODE: environment.eurogerm
        ? "Código ciclo"
        : "Código contenedor",
      CONTAINER: environment.eurogerm ? "Ciclo" : "Contenedor",
      START_CONTAINER: "Empezar",
      STOP_CONTAINER: environment.eurogerm
        ? "Acabar ciclo"
        : "Acabar contenedor",
      MUST_CLOSE_CONTAINER: environment.eurogerm
        ? "Antes de cerrar la producción debe cerrar los ciclos abiertos"
        : "Antes de cerrar la producción debe cerrar los contenedores abiertos",
      START_CONTAINER_ERROR: environment.eurogerm
        ? "No se ha podido iniciar el ciclo"
        : "No se ha podido iniciar el contenedor",
      STOP_CONTAINER_ERROR: environment.eurogerm
        ? "No se ha podido acabar el ciclo"
        : "No se ha podido acabar el contenedor",
      OF_EMPTY: "Actualmente no hay ninguna OF para esta máquina",
      NO_OBSERVATIONS: "No hay observaciones",
      SELF_SIGNED_CERT: "Certificado auto-firmado",
      SELF_SIGNED_CERT_MESSAGE:
        "Debe aceptar el certificado para poder comunicarse con la máquina",
      DOCUMENTATION: "Documentación",
      NAME: "Nombre",
      VIEW_FILE: "Visualizar archivo",
      PRINT_LAST_PRODUCTION: "Imprimir última etiqueta",
      CONTROLS: "Controles",
      AS: "Arranque serie",
      FS: "Fin de serie",
      ITU: "Inicio de turno",
      DA: "Después de una averia",
      PENDING_POINTS: "Cuestionarios de calidad pendientes",
      PENDING_POINT: "Cuestionario de calidad",
      OF_DE: "de",
      BACK: "Anterior",
      NEXT: "Siguiente",
      FINISH: "Finalizar",
      SUBMIT: "Enviar",
      PIECES: "Piezas",
      ERROR_STOPPING: "No se ha podido acabar la producción",
      EMERGENCY_STOP: "Parada d'emergencia",
      PROPOSE_STOP: "Parada propuesta",
      STOP: "Parada",
      SHUTDOWN: "Paro",
      OTHERS: "Otras",
      MACHINE_ON: "Encendido",
      PREPARATION: "Preparación",
      JUSTIFY_STOPS: "Justificar paradas",
      JUSTIFY_STOP: "Justificar parada",
      MANUAL: "Manual",
      STOP_TIME: "Tiempo de parada",
      JUSTIFY: "Justificar",
      READ: "Leer",
      QR_CODE: "Código QR etiqueta",
      COMPONENT_NAME: "Nombre componente",
      EXPIRATION: "Caducidad",
      ACCEPT_EXPIRED_COMPONENT: "Aceptar componente caducado",
      RESPONSIBLE_VALIDATION: "Validación para un responsable",
      RESPONSIBLE_USER_CODE: "Código usuario responsable",
      ACCEPT: "Aceptar",
      NO_LAST_PRODUCTION: "No se ha encontrado la última producción",
      NO_LAST_CONTAINER: environment.eurogerm
        ? "No se ha encontrado el último ciclo"
        : "No se ha encontrado el último contenedor",
      DATE: "Fecha",
      EXTRA_INFORMATION: "Información extra",
      CONFIGURATION: "Configuración",
      CONNECTING: "Conectando",
      OPEN: "Abierto",
      CLOSING: "Cerrando",
      CLOSED: "Cerrado",
      CURRENT_VERSION: "Versión actual",
      CHANGE: "Cambiar",
      CONFIGURATION_PASSWORD: "Contraseña de configuración",
      INCORRECT_PASSWORD: "Contraseña incorrecta",
      TRY_AGAIN: "Intentar otra vez",
      TEAMS: "Equipos",
      TEAM: "Equipo",
      SELECT_TEAM: "Seleccionar equipo",
      WORKERS_NOT_FOUND: "No se han encontrado operarios",
      COMPONENT_INDEX: environment.eurogerm
        ? "Ciclo {0} de {1}"
        : "Contenedor {0} de {1}",
      DIVIDE: "Dividir",
      ERROR_UPDATING_MEMBERS: "No se han podido actualizar los miembros",
      MODIFY_TEAM: "Modificar equipo",
      NO_MACHINES: "No hay máquinas disponibles",
      OEE: "OEE",
      FAULT: "Avería",
      CORRECTIVE: "Correctivo",
      PREVENTIVE: "Preventivo",
      SELECT_DEVICE_MODE: "Modo",
      MAINTENANCE: "Mantenimiento",
      AUTOMATIC: "Automático",
      DEFAULT_MACHINES: "Máquinas predeterminadas",
      MAXIMUM_DIFFERENCE_BETWEEN_REPORTED_AND_COUNTED_PIECES:
        "Máxima diferencia entre las piezas informadas y las contadas",
      MAXIMUM_DIFFERENCE_EXCEEDED: "Máxima diferencia superada",
      SHOW_INPUT_KG_UNIT_LOT: "Mostrar input para kg/unidad y lote",
      KG_UNIT: "kg/unidad",
      LOT: "Lote",
      BOX_CODE: "Código de box",
      SHOW_BOX_CODE: "Mostrar código de box",
      SOCKET_LOCAL_DISCONNECTED: "Socket Local Desconectado",
      SOCKET_LOCAL_DISCONNECTED_ERROR:
        "Se ha perdido la conexión del socket local, la aplicación no puede funcionar correctamente",
      TESTS: "Tests",
      RESPONSIBLE_PRODUCCION: "Responsable Producción",
      END: "Fin",
      NOK: "NOK",
      METERS: "Metros",
      LITERS: "Litros",
      BOXES: "Cajas",
      KG: "Kg",
      SACKS: "Sacos",
      NOK_JUSTIFIED_UNIT: "NOK {{unit}} justificadas",
      TOTAL_UNIT_NOK: "Total {{unit}} NOK",
      SHOW_STOP_SCREEN: "Mostrar pantalla de total de paradas",
      PER_CYCLE: "por ciclo",
      TOTAL_PLANNED_STOPS: "Total de paradas previstas",
      INCORRECT_USER_CODE: "Código de usuario incorrecto",
      PRODUCTIVITY: "Productividad",
      SHOW_DIVIDE_CONTAINER: environment.eurogerm
        ? "Mostrar dividir ciclo"
        : "Mostrar dividir contenedor",
      CLOSE_CONTAINER: environment.eurogerm
        ? "Cerrar ciclo"
        : "Cerrar contenedor",
      FROM_PREVIOUS_PRODUCTION: "De producciones anteriores",
      WAITING_BAR_CODE_LECTURE: "Esperando lectura de código de barras",
      ENTER_CODE_MANUALY: "Entrar código manualmente",
      SELECT_COMPONENT: "Selecciona componente",
      LOTS_ENTERED: "Lotes entrados",
      QUANTITY_CANT_BE_ZERO: "La cantidad no puede ser 0 o menor que 0",
      QUANTITY_CANT_BE_LESS_ZERO: "La cantidad no puede ser menor que 0",
      QUANTITY_CANT_BE_EDITED: "No se pudo editar la cantidad",
      NO_COMPONENTS: "No hay componentes",
      ERROR_SAVING_DATA: "Error guardando los datos",
      SURE_YOU_WANT_TO_LEAVE: "Seguro que quieres salir",
      CHANGES_WILL_NOT_BE_SAVED: "Si has realizado cambios, no se guardarán",
      ALL_IN_ONE_CONTAINER: environment.eurogerm
        ? "Todo en un solo ciclo"
        : "Todo en un solo contenedor",
      NO_CONTAINERS: environment.eurogerm
        ? "No hay ciclos disponibles"
        : "No hay contenedores disponibles",
      SELECT_NEW_CONTAINER: environment.eurogerm
        ? "Seleccionar nuevo ciclo"
        : "Seleccionar nuevo contenedor",
      ASK_FOR_MEASURES: "Preguntar por las medidas",
      HIDE_CADENCE: "Esconder cadencia",
      SHOW_CADENCE: "Mostrar cadencia",
      WARNING: "Atención",
      MACHINE_NOT_READY: "La máquina no está preparada",
      DB_PRINT_TEMPLATE_BUTTON: "Plantilla DB PRINT boton",
      PRODUCTION_START_COMMANDS: "Comandos a enviar en iniciar producción",
      MASTER_SLAVE_MODE: "Modo Master/Slave",
      NEXT_CONTAINER_NOT_SCANNED_COMPONENTS: environment.eurogerm
        ? "No se han verificado los componentes del próximo ciclo, debe verificarlos antes de continuar"
        : "No se han verificado los componentes del próximo contenedor, debe verificarlos antes de continuar",
      ADD_PREPARATION_COMPONENT: "Añadir componente de preparación",
      ADD_COMPONENTS: "Añadir componentes",
      COMPONENT_CODE: "Código componente",
      COMPONENT: "Componente",
      USE_PREVIOUS_LOTS: "Usar lotes anteriores",
      PREVIOUS_LOTS: "Lotes anteriores",
      ADD_PRODUCTION_COMPONENT: "Añadir componente",
      TEXT_PRODUCTION_BUTTON: "Texto boton de producción",
      TIME_INTERVAL_BUTTON: "Intervalo de tiempo boton de producción",
      HIDE_PRODUCTION_DETAIL: "Esconder detalle de producción",
      STATION_NAME_REQUIRED: "Se necesita un nombre de estación",
      STATION_NAME_REQUIRED_MSG:
        "Se necesita un nombre de estación antes de crear/modificar una configuración",
      STATION_NAME: "Nombre de la estación",
      EXPORT_CONFIGURATION: "Exportar",
      EDIT_CONFIGURATION: "Editar",
      IMPORT_CONFIGURATION: "Importar",
      CONFIGURATIONS: "Configuraciones",
      NO_CONFIGURATIONS: "Sin configuraciones",
      IMPORT_CONFIGURATION_QUESTION: "¿Importar configuración?",
      IMPORT_CONFIGURATION_QUESTION_MSG:
        "¿Desea importar y sobreescribir la configuración?",
      SAVE: "Guardar",
      SAVE_ALL_LOCAL: "Guardar todo localmente",
      GENERAL_TIME_INTERVAL_BUTTON:
        "Intervalo de tiempo general de los botones de producción",
      VERIFY_COMPONENTS: "Verificar componentes",
      VERIFY_COMPONENTS_ERROR: "Debe verificar los componentes antes",
      DB_PRINT_CONTAINER_TEMPLATE: environment.eurogerm
        ? "Comandos a enviar al cerrar un ciclo"
        : "Comandos a enviar al cerrar un contenedor",
      CLIENT_NOT_CONFIGURED: "Debe configurar el cliente",
      THE_SPECIFIED_CONTAINER_DOES_NOT_EXIST: environment.eurogerm
        ? "No existe el ciclo indicado"
        : "No existe el contenedor indicado",
      NEXT_CONTAINER_CODE: environment.eurogerm
        ? "Código del siguiente ciclo"
        : "Código del siguiente contenedor",
      EMPTY_NEXT_CONTAINER_CODE: environment.eurogerm
        ? "El código del siguiente ciclo no puede estar vacío, si quieres terminar la producción hágalo directamente"
        : "El código del siguiente contenedor no puede estar vacío, si quieres terminar la producción hágalo directamente",
      CONTAINERS: environment.eurogerm ? "Ciclos" : "Contenedores",
      ACTIVE_CONTAINERS: environment.eurogerm
        ? "Ciclos activos"
        : "Contenedores activos",
      PENDING_CONTAINERS: environment.eurogerm
        ? "Ciclos pendientes"
        : "Contenedores pendientes",
      NO_ACTIVE_CONTAINERS: environment.eurogerm
        ? "No hay ciclos activos"
        : "No hay contenedores activos",
      NO_PENDING_CONTAINERS: environment.eurogerm
        ? "No hay ciclos pendientes"
        : "No hay contenedores pendientes",
      NETWORK_SETTINGS: "Configuración de la red",
      EDIT_NETWORK_SETTINGS: "Editar configuración de la red",
      PASSWORD: "Contraseña",
      ADAPTER: "Adaptador",
      ROUND_COUNT_TO_NEAREST_HALF: "Redondear la cuenta total",
      SELECT_CONTAINER: "Seleccionar contenedor",
      CONTAINERS_EMPTY: "No hay contenedores",
      CLOSED_CONTAINERS: "Contenedores cerrados",
      CHANGE_OF: "Cambiar OF",
      SHOW_CHANGE_OF_BUTTON: 'Mostrar botón "Cambiar OF"',
      TOOLING: "Utillaje",
      AUTO_START_PRODUCTION_MODE: "Modo de inicio de producción automático",
      MINIMUM_CADENCE: "Cadencia mínima",
      MINIMUM_TIME: "Tiempo mínimo",
      CHANGE_REFERENCE: "Cambiar referencia",
      TOTAL_OF: "Cantidad total OF",
      PRODUCED: "Producida",
      MUST_START_MASTER_PRODUCTION_BEFORE:
        'Debe empezar la producción en la máquina "Master"',
      MASTER_IN_USE:
        'La máquina "Master" está siendo utilizada por otro operario, compruebe que se hayan cerrado las producciones',
      MUST_CLOSE_PRODUCTION_FROM_MASTER:
        'Debe cerrar la producción desde la máquina "Master"',
      GENERAL: "General",
      CLOUD: "Nube",
      BUTTONS: "Botones",
      COMMANDS: "Comandos",
      SHOW_JUSTIFY_NOK_BUTTON: 'Mostrar botón "Justificar NOK"',
      PRODUCTION_BUTTONS_VISIBLE: "Botones de producción visibles",
      LOTS: "Lotes",
      LOCATION: "Ubicación",
      DISABLE_ABILITY_TO_CHANGE_OK_NOK:'Deshabilitar la edición de cantidades OK/NOK al finalizar la producción',
      SELECT_A_COMPONENT: "Selecciona un componente",
    },
    FOOTER: {},
  },
};
